import {applyMiddleware, createStore} from 'redux';
import {taskMiddleware} from 'react-palm/tasks';

import reduxReducers from './reducers';

const store = createStore(reduxReducers, {
}, applyMiddleware(taskMiddleware));

export default store;
